<template>
  <div class="print-qrcode">
    <div class="bottom-title">
      <div class="bottom-text">打印水泵码</div>
    </div>
    <div class="submit-btn">
      <el-button
        style="margin-right: 10px;"
        type="primary"
        size="small"
        :loading="printLoading"
        @click="onClickPrint"
      >开始打印</el-button>
      <el-button style="margin-right: 20px;" type="primary" size="small" @click="onChangeStep">我的申请</el-button>
      <div class="submit-text" @mouseenter="onMouseEnter" @mouseleave="onMouseEnter">预览水泵码</div>
      <transition name="el-zoom-in-top">
        <el-image
          v-show="showPrintImg"
          class="submit-img"
          :src="companyInfo.qrContent"
          :preview-src-list="qrCodeList"
        ></el-image>
      </transition>
    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
          ref="refTable"
          @select-all="onChangeTableAll"
          @selection-change="onChangeTableSelection"
          :data="tableData"
          border
        >
          <el-table-column type="selection" align="center" width="45"></el-table-column>
          <el-table-column type="index" align="center" width="40"></el-table-column>
          <el-table-column
            prop="waterPumpCode"
            show-overflow-tooltip
            align="center"
            width="250"
            label="水泵码"
          ></el-table-column>
          <el-table-column prop="enterpriseCode" show-overflow-tooltip align="center" label="企业码"></el-table-column>
          <el-table-column
            prop="productCode"
            show-overflow-tooltip
            align="center"
            label="产品码"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="serialNumber"
            show-overflow-tooltip
            align="center"
            label="序列号"
            width="100"
          ></el-table-column>
          <el-table-column
              prop="printStatus"
              show-overflow-tooltip
              align="center"
              label="打印状态"
              width="120"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.printStatus==='FINISH'" type="success">
                已打印
              </el-tag>
              <el-tag v-else type="info">
                未打印
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="shelfLife"
              show-overflow-tooltip
              align="center"
              label="质保期"
              width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.shelfLife && scope.row.registerDate">{{ calcWarrantyRemain(scope.row) }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createDate"
            show-overflow-tooltip
            align="center"
            label="创建时间"
            width="200"
          ></el-table-column>
          <el-table-column
              prop="registerDate"
              show-overflow-tooltip
              align="center"
              label="注冊时间"
              width="200"
          ></el-table-column>

        </el-table>
        <el-pagination
          style="margin-top: 20px;"
          @current-change="onChangeCurrent"
          @size-change="onChangeSize"
          :current-page="queryParams.current"
          :page-size="queryParams.pageSize"
          background
          :page-sizes="[5, 20, 50, 100, 500]"
          layout="total, sizes, prev, pager, next"
          :total="queryParams.total"
        ></el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt style="width:200px" />
      </div>
    </div>
    <el-dialog
      title="水泵码打印信息"
      :destroy-on-close="true"
      :visible.sync="printDialogVisible"
      lock-scroll
      append-to-body
      width="435px"
    >
      <div id="nbprint">
        <!-- 打印的样式必须写在行内，写在class则无效 -->
        <div v-if="modelType=='1'" >
          <div
            v-for="(item, index) in multipleSelection"
            :key="index"
            style="width: 435px;height:327px; margin: 0px 0 6px 0;display: block;position: relative;box-sizing:border-box;"
            v-bind:style="{backgroundImage:'url(' + oneBgUrl + ')',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}"
          >
            <img
              id="2wm"
              title="水泵码"
              :src="item.qrContent"
              alt="水泵码"
              style="width:125px;height:125px;position: absolute; right:60px;top:145px; transform: translateY(-50%);"
            />
            <!--新华泵业的条码去掉、显示产品码-->
            <div v-if="item.enterpriseUuid=='8a6a62c18991b83d0189d8f0f12701ce'" class="code" style="position: absolute;width: 100%;bottom:15px;margin: 0 auto;">
              <div
                  style="display: block;margin: 0 auto;font-size: 13px;text-align: center;margin-bottom:2px"
              >型号:{{ productModel }}</div>
             <div style="height: 15px"></div>
              <div
                  style="width: 260px;display: block;margin: 0 auto;font-size: 13px;text-align: center;position: absolute;bottom: -2px;left: 50%;transform: translateX(-50%);"
              >{{ item.productCode }}</div>
            </div>

            <div v-else class="code" style="position: absolute;width: 100%;bottom:6px;margin: 0 auto;">
              <div
                style="display: block;margin: 0 auto;font-size: 12px;text-align: center;font-size:8px;margin-bottom:2px"
              >型号:{{ productModel }}</div>
              <barcode
                style="text-align:center;height:100%"
                :format="CODE39"
                :displayValue="false"
                :value="item.productCode"
                :width="1.2"
                :margin-left="2"
                :margin-right="2"
                :margin-top="1"
                :margin-bottom="0"
                :height="30"
                :text-margin="3"
                :font-size="12"
              >条码打印失败</barcode>
              <div v-if="item.enterpriseUuid=='8a6a62c28991b8390189be8f911e0010'"
                   style="width: 260px;display: block;margin: 0 auto;font-size: 12px;text-align: center;font-size:8px;position: absolute;bottom: -2px;left: 50%;transform: translateX(-50%);"
              >{{ item.productCode }}</div>
              <div  v-else
                style="width: 260px;display: block;margin: 0 auto;font-size: 12px;text-align: center;font-size:8px;position: absolute;bottom: -2px;left: 50%;transform: translateX(-50%);"
              >{{ item.waterPumpCode }}</div>
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-for="(item, index) in multipleSelection"
            :key="index"
            style="width: 435px;height:298px; margin: 0px 0 6px 0;display: block;position: relative;box-sizing:border-box;"
            v-bind:style="{backgroundImage:'url(' + twoBgUrl + ')',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}"
          >
            <div style="width: 100%; height: 100%;margin: 0px auto;position: relative;">
              <img
                style="width:140px;height:140px;position: absolute; right:66px;top:115px; transform: translateY(-50%);"
                :src="item.qrContent"
              />
              <div
                id="qrCodemodel"
                style="position:absolute;width: 38%;bottom:33%;left:50%;color:#000;font-size:10px;color:#000;white-space:nowrap;text-align:center"
              >
                {{
                item.productCode.length > 15 ? item.productCode.substring(item.productCode.length - 15, item.productCode.length) : item.productCode
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-print="printOption" type="primary" size="mini" :loading="printLoading">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEnterprise,
  queryCodeTraceabilityTranslationList, updataTranslationDetailPrint
} from "../../utils/interface";
import modelOne from "@/assets/model_one.png";
import modeltwo from "@/assets/model_two.jpg";

export default {
  components: {},
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      tableAllData: [],
      productData: {},
      oneBgUrl: modelOne,
      twoBgUrl: modeltwo,
      queryParams: {
        enterpriseUuid: "",
        productCode: "",
        mainUuid: "",
        current: 1,
        pageSize: 5,
        total: 0
      },
      enumStatus: [
        {
          value: "INIT",
          name: "未审核"
        },
        {
          value: "REVIEW",
          name: "已审核"
        },
        {
          value: "NOT_PASS",
          name: "审核不通过"
        },
        {
          value: "REVIEW_PASS",
          name: "审核通过"
        },
        {
          value: "FINISH",
          name: "已生成"
        }
      ],
      listLoading: false,
      printLoading: false,
      qrCodeList: [],
      showPrintImg: false,
      companyInfo: {},
      printDialogVisible: false,
      printOption: {
        id: "nbprint", // 打印元素的id 不需要携带#号
        preview: false, // 开启打印预览
        previewTitle: "", // 打印预览标题
        popTitle: "水泵码", // 页眉标题 默认浏览器标题 空字符串时显示undefined 使用html语言
        // 头部文字 默认空 在节点中添加 DOM 节点， 并用,(Print local range only)分隔多个节点
        extraHead: "",
        // 新的 CSS 样式表， 并使用,（仅打印本地范围）分隔多个节点
        extraCss: "",
        previewBeforeOpenCallback: () => {
          console.log("触发打印预览打开前回调");
        },
        previewOpenCallback: () => {
          console.log("触发打开打印预览回调");
        },
        beforeOpenCallback: () => {
          console.log("触发打印工具打开前回调");
        },
        openCallback: () => {
          console.log("触发打开打印工具回调");
        },
        closeCallback: () => {
          console.log("触发关闭打印工具回调");
          this.printAfter();
        },
        clickMounted: () => {
          console.log("触发点击打印回调");
        }
      },
      modelType: "1",
      productModel: "",
      mainProductInfo:{},
    };
  },
  created() {},
  methods: {
    initData(product) {
      this.productData = product;
      this.modelType = this.productData.modelType;
      this.productModel = this.productData.productModel;
      this.queryParams.enterpriseUuid = product.enterpriseUuid;
      this.queryParams.productCode = product.productCode;
      this.queryParams.mainUuid = product.uuid;
      this.getPageList();
      this.getCompanyEnterprise();
    },
    getPageList() {
      this.listLoading = true;
      queryCodeTraceabilityTranslationList(this.queryParams)
        .then(res => {
          this.listLoading = false;
          if (res.list) {
            this.tableData = res.list;
            this.queryParams.total = res.total;
          }
        })
        .catch(err => {
          this.listLoading = false;
        });
    },
    getCompanyEnterprise() {
      getEnterprise().then(res => {
        if (res.data) {
          this.companyInfo = res.data;
          this.qrCodeList = [res.data.qrContent];
        }
      });
    },
    onClickPrint() {
      if (this.multipleSelection.length > 0) {
        this.printDialogVisible = true;
      } else {
        this.$message.warning("请选择要打印的水泵码!");
      }
    },
    onChangeStep() {
      this.$emit("onChangeStep", 1);
      this.$emit("onChangeType", 1);
    },
    onChangeTableSelection(selection) {
      console.info("==========selection======");
      console.info(selection);
      this.multipleSelection = selection;
    },
    onChangeTableAll() {
      // this.$refs.refTable.clearSelection()
    },
    onMouseEnter() {
      this.showPrintImg = !this.showPrintImg;
    },
    onInputChange() {
      this.$nextTick(() => {
        this.getPageList();
      });
    },
    onChangeCurrent(e) {
      this.queryParams.current = e;
      this.getPageList();
    },
    onChangeSize(e) {
      this.queryParams.pageSize = e;
      this.getPageList();
    },
    calcWarrantyRemain(row) {
      const registerDate = new Date(row.registerDate.replace(/-/g, '/'))
      const shelfLife = Number(row.shelfLife)
      if (isNaN(shelfLife) || !registerDate.getTime()) return '-'
      const now = new Date()
      const remainMs = registerDate.getTime() + shelfLife * 24 * 60 * 60 * 1000 - now.getTime()
      const remainDays = Math.ceil(remainMs / (24 * 60 * 60 * 1000))
      if (remainDays <= 0) {
        return '已过期'
      }
      return remainDays + ' 天'
    },
    eachDictName(status) {
      return this.enumStatus.find(item => item.value === status).name;
    },
    base64ImgtoFile(dataurl, filename = "file") {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const suffix = mime.split("/")[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      });
    },
    printAfter(){
      let uuidList = [];
      for(var i = 0; i< this.multipleSelection.length; i++){
        // console.log('id:'+this.multipleSelection[i].uuid)
        uuidList.push(this.multipleSelection[i].uuid)
      }
      if (uuidList.length>0){
        updataTranslationDetailPrint(uuidList).then((res) => {
          console.log(res)
        }).catch(err => {

        })
      }
    },
  }
};
</script>

<style scoped lang="less">
/deep/ .el-dialog__body {
  overflow-y: auto !important;
  //height: 60vh !important;
  padding: 0px !important;
}

/deep/ .el-card__body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.print-qrcode {
  .bottom-title {
    border-bottom: 1px solid #cccccc;
    padding-bottom: 20px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }

  .bottom-text {
    color: black;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 2px;
  }

  .submit-btn {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .submit-img {
    width: 120px;
    height: 120px;
    position: absolute;
    left: 300px;
    bottom: -70px;
    z-index: 9;
  }

  .submit-text {
    align-items: center;
    cursor: pointer;
  }

  .submit-text:hover {
    color: #409eff;
  }
  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }

  /deep/ .el-form-item__content {
    width: calc(100% - 100px);
  }

  /deep/ .el-form--inline .el-form-item {
    width: 100%;
  }
}
@media print {
  #nbprint {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    #2wm {
      right: 0;
    }
    #qrCode1Bg1 {
      //display: none;
      //visibility: hidden;
    }
    #qrCode2Bg2 {
      //display: none;
      //visibility: hidden;
    }
  }
}
</style>
<style media="print" scoped lang="less">
/*去除打印的页眉页脚*/
@page :left {
  margin-left: 0cm;
  padding-left: 0cm;
}

@page :right {
  margin-left: 0cm;
  padding-left: 0cm;
}
</style>




// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoPrintQrcode.vue